module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user/consignee/shared/consignee-form/consignee-form.component.scss
// module id = ./src/app/user/consignee/shared/consignee-form/consignee-form.component.scss
// module chunks = main